import getScriptJs from 'ha/helpers/scriptjsWrapper';

/* globals FB */
let initialized = false;

export default appId =>
  new Promise((resolve, reject) => {
    if (__SERVER__) {
      reject(new Error('calling client side code on server'));

      return;
    }
    if (initialized) {
      resolve(global.FB);

      return;
    }

    global.fbAsyncInit = () => {
      global.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.10',
      });
      global.FB.AppEvents.logPageView();
      initialized = true;
      resolve(global.FB);
    };

    getScriptJs('https://connect.facebook.net/en_US/sdk.js');
  });
